import {SequenceAnnotationConfig} from 'antibodies/domain-annotation/DomainAnnotationTypes';
import * as TaskRunner from 'util/TaskRunner';

/**
 * Keep in sync with AnnotateDomainSequencesTaskResult in
 * benchling/antibodies/antibody_awareness/tasks/annotate_domain_sequences_task.py.
 */
export interface AnnotateDomainSequencesResult {
  datasetId: string;
  results: Array<{sequenceId: string; error: string | null}>;
}

/** Annotates existing domain sequences, resolving once the annotation task finishes. */
export function annotateDomainSequences({
  sequenceIds,
  config,
}: {
  sequenceIds: Array<string>;
  config: SequenceAnnotationConfig;
}): Promise<AnnotateDomainSequencesResult> {
  return TaskRunner.postJSONPromise({
    url: '/1/api/domain-sequences:annotate',
    data: {
      sequenceIds,
      componentSequenceType: config.sequenceType,
      germlineId: config.germlineId,
      folderId: config.folderId,
      geneticCode: config.geneticCode,
    },
  });
}
